module.exports = __webpack_public_path__ + "img/yuding.fc8ca4f2.png";